import axios, { AxiosError } from 'axios';
import { authService } from './authService';
import { API_BASE_URL } from '../config';

// ✅ NEW: A more robust API service instance.
const api = axios.create({
  baseURL: API_BASE_URL,
  // ✅ FIX: Removed the default 'Content-Type' header.
  // Axios will now correctly set it to 'application/json' for objects
  // and 'multipart/form-data' for FormData.
});

// ✅ Interceptor 1: Request Middleware 
// Adds the auth token and country scoping to every outgoing request.
api.interceptors.request.use(
  (config) => {
    // 1. Auth Token
    const token = authService.getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 2. Global Country Scoping (Multi-Region Ready for Partners)
    const activeCountryId = localStorage.getItem('active_country_id');
    if (activeCountryId) {
       if (!config.params) config.params = {};
       config.params.country_id = activeCountryId;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Interceptor 2: Response Middleware
// Handles global errors, especially 401 Unauthorized for session expiry.
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // If the error is a 401, the user's token is invalid or expired.
    // If the error is a 401, the user's token is invalid or expired.
    // However, if we are specifically trying to login (accessing /token), 
    // we should NOT redirect; we should let the login form handle the invalid credentials error.
    if (error.response?.status === 401) {
        const isLoginRequest = error.config?.url?.includes('/token');
        const isLoginPage = window.location.pathname.includes('/login');

        if (!isLoginRequest && !isLoginPage) {
            authService.clearToken();
            // Force a page reload to clear all application state and redirect.
            window.location.href = '/';
        }
    }
    
    // Standardize the error object before passing it down.
    const customError = {
      ...error,
      message: (error.response?.data as { detail?: string })?.detail || 'An unexpected error occurred. Please try again.',
    };
    
    return Promise.reject(customError);
  }
);

export default api;
